// @flow
import * as React from 'react';
import styled from 'styled-components';


const StyledAsterisk = styled.span`
    font-weight: ${(props) => props.theme.formField.required.fontWeight};
    color: ${(props) => props.theme.formField.required.color || props.theme.global.colors.brand};
    ${(props) => props.theme.formField.required.extend}
`;

const RequiredAsterisk = () => <StyledAsterisk>*</StyledAsterisk>;

export default RequiredAsterisk;
